import React, { useEffect, useState } from "react";
import ReactSplit, { SplitDirection } from "@devbookhq/splitter";
import { LinearProgress } from "@mui/material";
import FilePanel from "./FilePanel/FilePanel";
import FormPanel from "./FormPanel/FormPanel";
import { PagesProvider } from "../Contexts/InvoicePages";

import { SnackbarProvider } from "notistack";
import { BACKEND_URL, CONSUMER_URL } from "../../helpers/variables";

const ReviewPage = ({ bill, file, email, close }) => {
  const [invoice, setInvoice] = useState();

  useEffect(() => {
    if (![-4, -1].includes(bill?.bill_status)) fetchInvoice();
    else setInvoice({});
  }, [bill]);

  async function fetchInvoice() {
    setInvoice();
    const res = await fetch(`${CONSUMER_URL}/get_invoice?bill_id=${bill?._id}`);
    setInvoice(res.ok ? await res.json() : {});
  }

  return invoice ? (
    <SnackbarProvider>
      <PagesProvider>
        <ReactSplit
          direction={SplitDirection.Horizontal}
          initialSizes={[55, 45]}
        >
          <FilePanel bill={bill} file={file} email={email} invoice={invoice} />
          <FormPanel
            bill={bill}
            file={file}
            email={email}
            invoice={invoice}
            close={close}
          />
        </ReactSplit>
      </PagesProvider>
    </SnackbarProvider>
  ) : (
    <LinearProgress />
  );
};

export default ReviewPage;
